import cx from 'classnames'
import { TFunction } from 'i18next'
import i18n from '../../../../../../../client/src/i18n'
import { displayS3File } from '../../../../../../../client/src/utils/s3'
import { EndUserCampaign, PartialEndUser } from '../../../../../lib/api/types'
import { endUserType } from '../../../../../utils/user-type'
import styles from './style.module.css'

export default function Success({
  campaign,
  endUser,
  t,
}: {
  campaign: EndUserCampaign
  endUser: PartialEndUser
  t: TFunction<'translation', undefined>
  pathname: string
  id?: string
  navigate: (path: string) => void
}) {
  const language = i18n.language
  const typeOfUser = endUserType(endUser.referral)

  const translations =
    campaign?.ecFlowTexts?.ecFlowTexts?.[typeOfUser]?.['success']?.[language]

  const { logo } = campaign
  const themeLogo = campaign?.customer?.endUserTheme?.logoUrl

  const isFlyer = campaign.postcardTemplate?.['type'] === 'flyer'

  return (
    <div
      className={cx(
        'grid justify-around bg-cover max-w-sm w-full mx-auto px-6',
      )}
    >
      <div
        className={cx(
          styles.contentWrapper,
          'flex flex-col items-center gap-8 text-center m-auto',
        )}
      >
        {themeLogo ? (
          <img src={themeLogo} className='my-8 max-h-20 max-w-70 w-auto object-contain' />
        ) : (
          logo && <img src={displayS3File(logo)} className="w-32" />
        )}


        <h1 className="text-2xl font-weight-light text-slate-50">
          {isFlyer
            ? translations?.header ?? t('ec.success.flyer_title')
            : translations?.header ?? t('ec.success.title')}
        </h1>
        <p
          className="text-xl text-slate-50"
          dangerouslySetInnerHTML={{
            __html: translations?.text
              ?? t('ec.success.sub_title'),
          }}
        />
      </div>
    </div>
  )
}
